import { SET_CONTENT } from "./actionType";
export const setPreviewContent = (content) => ({
  type: SET_CONTENT,
  payload: content,
});
